import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const GOLD = "#e7b53a";
const GOLD_HI = "#f7d877";

function coinStack(cx: number, cy: number, cz: number, r: number, n: number): Part[] {
  const out: Part[] = [];
  for (let i = 0; i < n; i++) {
    out.push({ geometry: new THREE.CylinderGeometry(r, r, 0.012, 9), color: i % 2 ? GOLD_HI : GOLD, position: [cx, cy + 0.013 * i, cz] });
  }
  return out;
}

export const coinStackModel = defineModel({
  id: "coin-stack",
  batchId: "characters",
  name: "Coin stack",
  tags: ["good", "cargo", "precious"],
  fits: ["carry"],
  summary: "Three stacks of minted coins -- a carriable good for an avatar's carry socket.",
  description:
    "Three small coin stacks at held scale, ported from age-of-mcp's goods " +
    "(`coin`). Mount it in a player's or worker's `carry` socket to show the " +
    "figure hauling coins.",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: (): Part[] => [
    ...coinStack(-0.03, 0.0, 0.0, 0.035, 4),
    ...coinStack(0.03, 0.0, 0.01, 0.035, 3),
    ...coinStack(0.0, 0.0, -0.03, 0.035, 5),
  ],
  animations: [],
});
